import Service, { service } from "@ember/service";
import { task, timeout } from "ember-concurrency";
import ENV from "glesys-controlpanel/config/environment";
import { findRecord } from "@warp-drive/legacy/compat/builders";

export default class PaymentCardService extends Service {
  @service ajax;
  @service intl;
  @service notification;
  @service store;

  fetchPaymentCardUrl = task(async (organizationId) => {
    let {
      paymentcard: { url },
    } = await this.ajax.post(`${ENV.apiBaseUri}/paymentcard/add`, {
      data: {
        language: "EN",
        customernumber: organizationId,
      },
    });

    if (!url) {
      this.notification.add(
        "error",
        this.intl.t("component.organization-payment-method.error-fetching-payment-card-url.title"),
        this.intl.t("component.organization-payment-method.error-fetching-payment-card-url.description"),
      );
    }
    return url;
  });

  checkForNewAddedCard = task(async (organization) => {
    let oldCard = organization.paymentCard?.createdat;

    while (true) {
      await timeout(ENV.environment === "test" ? 0 : 10 * 1000);
      await this.store.request(findRecord("organization", organization.id, { reload: true }));

      if (oldCard !== organization.paymentCard?.createdat) {
        return true;
      }
    }
  });
}
